import React from 'react';
import moment from 'moment';
import AdminOptions from 'shared/components/AdminOptions';
import { Controls, validators } from 'shared/helper/form';
import Date from 'researcher/helpers/date';
import { T } from 'shared/helper/translate';
var deadlineMessage = 'Input the deadline in your local time zone, the deadline will be displayed to the customer ' + 'in their local time zone';
var Datepicker = Controls.Datepicker;
var notEmpty = validators.notEmpty;
var OrderDates = function OrderDates(_ref) {
  var deadlineAvailable = _ref.deadlineAvailable,
    editingOrderDetails = _ref.editingOrderDetails,
    order = _ref.order,
    deadlineMismatch = _ref.deadlineMismatch,
    newDeadline = _ref.newDeadline,
    updateDeadline = _ref.updateDeadline,
    showExactTime = _ref.showExactTime;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Date created"
  })), /*#__PURE__*/React.createElement(Date, {
    source: order.createdAt
  })), deadlineAvailable ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Due date"
  })), editingOrderDetails ? /*#__PURE__*/React.createElement(AdminOptions, null, /*#__PURE__*/React.createElement(Datepicker, {
    messages: {
      notEmpty: 'A deadline is required'
    },
    name: "deadline",
    placeholder: "Deadline",
    popperPlacement: "bottom-start",
    showTimeSelect: true,
    styles: {
      wrapper: 'mb-3 mb-0 pb-0',
      controlClass: 'mb-0 pb-0 pt-0'
    },
    validators: {
      notEmpty: notEmpty
    },
    description: deadlineMessage,
    timeIntervals: 30
  }), deadlineMismatch ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement("strong", null, "Suggested deadline"), /*#__PURE__*/React.createElement("br", null), moment(newDeadline).format('YYYY-MM-DD HH:mm'), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return updateDeadline(newDeadline);
    },
    className: "btn btn-small btn-primary py-1 px-2 mt-2"
  }, "Use this deadline")) : null) : /*#__PURE__*/React.createElement(Date, {
    source: order.deadline,
    showExactTime: showExactTime
  })) : null, !deadlineAvailable && order.completedAt && order.completed ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Date completed"
  })), /*#__PURE__*/React.createElement(Date, {
    source: order.completedAt
  })) : null);
};
export default OrderDates;